<script setup lang="ts">
import { computed } from 'vue'
import UIKit from '@pocketprep/ui-kit'
import LMBottomRightBlob from '@/components/RecallChallenge/LockedRecallChallengeCardBlobs/LMBottomRightBlob.vue'
import DMBottomRightBlob from '@/components/RecallChallenge/LockedRecallChallengeCardBlobs/DMBottomRightBlob.vue'
import MobileLMBottomRightBlob
    from '@/components/RecallChallenge/LockedRecallChallengeCardBlobs/MobileLMBottomRightBlob.vue'
import MobileDMBottomRightBlob
    from '@/components/RecallChallenge/LockedRecallChallengeCardBlobs/MobileDMBottomRightBlob.vue'
import { userModule } from '@/store/user/module'
import { screenModule } from '@/store/screen/module'

const {
    Icon,
} = UIKit

const isDarkMode = computed(() => {
    return userModule.state.settings.isDarkMode
})

const breakpoint = computed(() => {
    return screenModule.getters.getBreakpoint()
})

</script>

<template>
    <div v-dark class="locked-recall-challenge-card">
        <div v-dark class="locked-recall-challenge-card__title">
            Recall Challenge
        </div>
        <Icon
            v-dark
            class="locked-recall-challenge-card__lock-icon"
            type="lock"
            aria-label="Locked"
        />
        <div v-dark class="locked-recall-challenge-card__description">
            A customized set of questions to reinforce everything you've learned on your Level Up Journey.
        </div>
        <div v-dark class="locked-recall-challenge-card__how-to-unlock">
            Complete all subjects to unlock.
        </div>
        <div
            v-if="breakpoint !== 'black-bear'"
        >
            <DMBottomRightBlob
                v-if="isDarkMode"
                class="locked-recall-challenge-card__blob"
            />
            <LMBottomRightBlob
                v-else
                class="locked-recall-challenge-card__blob"
            />
        </div>
        <div v-else>
            <MobileDMBottomRightBlob
                v-if="isDarkMode"
                class="locked-recall-challenge-card__blob"
            />
            <MobileLMBottomRightBlob
                v-else
                class="locked-recall-challenge-card__blob"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.locked-recall-challenge-card {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 520px;
    height: 240px;
    border-radius: 5px;
    border: 0.5px solid $fog;
    background: $barely-background;
    box-shadow: 0px 1px 2px 0px rgb(31, 53, 69, 0.00);

    &--dark {
        border-radius: 5px;
        border: 0.5px solid $pickled-bluewood;
        background: $evening;
        box-shadow: 0px 1px 2px 0px rgb(3, 16, 27, 0.00);
    }

    @include breakpoint(black-bear) {
        width: 340px;
        height: 264px;
        align-items: center;
    }

    &__title {
        padding-left: 24px;
        margin-top: 16px;
        margin-bottom: 16px;
        color: $brand-black;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;

        &--dark {
            color: $white;
        }

        @include breakpoint(black-bear) {
            padding-left: 0;
            margin-bottom: 21px;
        }
    }

    &__lock-icon {
        position: absolute;
        top: 8px;
        right: 10px;
        width: 30px;
        height: 31px;
        color: $slate;

        &--dark {
            color: $white;
        }
    }

    &__description {
        width: 443px;
        color: $ash;
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        margin-left: 24px;
        margin-bottom: 16px;

        &--dark {
            color: $barely-background;
        }

        @include breakpoint(black-bear) {
            width: 283px;
            margin-left: 0;
            height: 60px;
            text-align: center;
        }
    }

    &__how-to-unlock {
        color: $brand-black;
        font-size: 15px;
        font-weight: 500;
        line-height: 20px;
        margin-left: 24px;

        &--dark {
            color: $white;
        }

        @include breakpoint(black-bear) {
            margin-left: 0;
        }
    }

    &__blob {
        position: absolute;
        bottom: 0;
        right: 0;
    }
}
</style>
